/**
 * Skeleton loading state for deal product cards
 */

interface Props {
  count?: number;
}

function SkeletonCard() {
  return (
    <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden animate-pulse">
      {/* Image Skeleton */}
      <div className="aspect-square bg-gradient-to-br from-gray-100 to-gray-200">
        <div className="w-full h-full flex items-center justify-center">
          <div className="w-24 h-24 bg-gray-200 rounded-lg" />
        </div>
      </div>

      {/* Content Skeleton */}
      <div className="p-4 space-y-3">
        {/* Title */}
        <div className="space-y-2">
          <div className="h-4 bg-gray-200 rounded w-3/4" />
          <div className="h-4 bg-gray-200 rounded w-1/2" />
        </div>

        {/* Product Code */}
        <div className="h-3 bg-gray-100 rounded w-24" />

        {/* Price */}
        <div className="flex items-baseline gap-2">
          <div className="h-7 bg-gray-200 rounded w-20" />
          <div className="h-4 bg-gray-100 rounded w-14" />
        </div>

        {/* Savings Chip */}
        <div className="h-5 bg-gray-100 rounded-full w-24" />

        {/* Footer */}
        <div className="pt-3 border-t border-gray-100 space-y-2">
          <div className="h-3 bg-gray-100 rounded w-32" />
          <div className="h-3 bg-gray-100 rounded w-24" />
        </div>
      </div>
    </div>
  );
}

/**
 * Mystery box skeleton for loading state
 */
function MysteryBoxSkeletonCard() {
  return (
    <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl shadow-sm border border-gray-700 overflow-hidden animate-pulse">
      {/* Image Skeleton with mystery overlay */}
      <div className="aspect-square bg-gray-800 relative">
        <div className="w-full h-full flex items-center justify-center">
          <div className="w-20 h-20 bg-gray-700 rounded-full" />
        </div>
        {/* Mystery badge skeleton */}
        <div className="absolute top-3 left-3 h-6 w-20 bg-gray-700 rounded-full" />
      </div>

      {/* Content Skeleton */}
      <div className="p-4 space-y-3">
        <div className="h-4 bg-gray-700 rounded w-3/4" />
        <div className="h-3 bg-gray-700 rounded w-1/2" />
        <div className="h-8 bg-gray-700 rounded-full w-full mt-4" />
      </div>
    </div>
  );
}

export default function DealsCardSkeleton({ count = 8 }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

export function MysteryBoxSkeleton({ count = 4 }: Props) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <MysteryBoxSkeletonCard key={i} />
      ))}
    </div>
  );
}
